import React, { useState, useContext} from 'react';
import PropTypes from 'prop-types';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import Loading from 'components/Loading';
import LoginService from 'services/Login/service';
import SessionFactory from 'factories/Session';
import { AuthContext } from '../../auth/AuthContext';
import { types } from '../../types/types';
import { social_auth } from 'config';
import './style.scss';

const SocialAuth = ({ showFacebook = true, showGoogle = true, actionCall = null,disablebuttons=false, legal = null ,handleTool = null,handleLoginValidation=null,handleLoginData=null,documentInfo = null }) => {

    const { sessionDispatch } = useContext(AuthContext);
    const [isLoadingFacebook, setIsLoadingFacebook] = useState(false);
    const [isLoadingGoogle, setIsLoadingGoogle] = useState(false);
    const [processErrorMsg, setProcessErrorMsg] = useState('');


   


      //erick
    const handleTooltip = () => {
        handleTool();
    }
  
    //end
    const responseFacebook = (response) => {
        if(response.accessToken){
            setIsLoadingFacebook(true);
            processResponseAuth('facebook', response);
        }else
            console.error(response);
    }
    const responseGoogle = (response) => {
        if(response.accessToken){
            setIsLoadingGoogle(true);
            processResponseAuth('google', response);
        }else
            console.error(response);
    }
    const processResponseAuth = async(scope = '', data = {}) => {
        //get ip Public
        const ip_public = await  LoginService.ipifyIpPublic();
        if (actionCall === 'register' && !documentInfo?.documentNumber) {
            // Mostrar mensaje de error
            setProcessErrorMsg('El campo de número de documento está vacío');
            setIsLoadingGoogle(false);
            return;
        }
        switch(actionCall){
            
            case 'register':
            case 'login':
                
                
                Promise.all([LoginService.authWithSocial(scope, 
                    { 
                        token: data.accessToken ,
                        'originWeb': 1,
                        'privacyPolicies': legal?.privacyPoliciesChecked? 1 : 0,
                        'termConditions': legal?.termConditionsChecked? 1 : 0,
                        'legalOthers': legal?.legalOthersChecked? 1 : 0,
                        'documentCode':documentInfo?.documentCode || '', // Agrega esta línea
                        'documentNumber':documentInfo?.documentNumber || '',

                    
                    })]).then(auth => {

                    
                    
                   //date session
                    const iniciotimeSession=new Date();
                   // service usuariolog
                    LoginService.crearUsuarioLog({
                    'internalCode': auth[0].internalCode,
                    'jwt':data.accessToken,
                    'correo':data.userName,
                    'ipPublica': ip_public,
                    'tipoEvento':"Sign in ("+scope+")",
                    'timeSessionSeconds':0,
                    'descripcion':"{loginApp"+ scope +" internalCode:"+ auth[0].internalCode +",message:"+auth[0].message+"}",
                    'socialScope':scope
                    
                    });
                    //
                    SessionFactory.saveUpdateTries(auth[0].payload,'login');



                    if(!auth || !['200','201'].includes(auth[0].internalCode)){
                        switch(scope){
                            case 'facebook': setIsLoadingFacebook(false); break;
                            case 'google': setIsLoadingGoogle(false); break;
                        }
                        setProcessErrorMsg('Usuario y/o contraseña incorrecta');
                        return;
                    }
                    if(['200','201'].includes(auth[0].internalCode) && (!auth[0].payload.validateUserByDni)){
                        switch(scope){
                            case 'facebook': setIsLoadingFacebook(false); break;
                            case 'google': setIsLoadingGoogle(false); break;
                        }
                        const loginData = {
                            loginApp: auth[0].payload,
                            login: data.accessToken
                          };
              
                        handleLoginData(loginData);
                        if (handleLoginValidation) {
                            handleLoginValidation(true);
                        }
                      
                        return;
                    }
                    sessionDispatch({
                        type: types.login,
                        payload: SessionFactory.initialize(auth[0].payload.additionalFields.jwt,data.accessToken,iniciotimeSession,scope)
                    });
                });
                break;
        }
    }

    return (
        
         <>
        {showFacebook 
            ? 
            <>
            { disablebuttons ? <> 

                    <button onClick={handleTooltip } className={"btn btn-connect-social btn-facebook-disabled no-hover  "}>
                         <span>Ingresar con Facebook</span>
                       
                    </button>

             </> 
             : 
             <FacebookLogin
                appId={social_auth.facebook_id}
                fields="name,email,picture"
                callback={responseFacebook} 
                textButton="Ingresar con Facebook" 
                cssClass={'btn btn-connect-social btn-facebook no-hover btn-facebook-button ' + (isLoadingFacebook && 'btn-is-loading')} 
                //isDisabled={disablebuttons}
                render={renderProps => (
                    
                    <button onClick={renderProps.onClick } className={"btn btn-connect-social btn-google no-hover "}>
                        {isLoadingFacebook ? <Loading /> : <span>Ingresar con Facebook</span>}
                    </button>
                    
                )}
            />

            }

            <br />
            </>
            :
            ""
        }
        {showGoogle 
            ?
            <GoogleLogin
                clientId={social_auth.google_id}
                buttonText="Ingresar con Google"
                onSuccess={responseGoogle}
                onFailure={responseGoogle}
                cookiePolicy={'single_host_origin'}
                render={renderProps => (
                    
                    <button onClick={ () => {
                        {disablebuttons ? 
                        handleTooltip()
                        :
                        renderProps.onClick()}  
                    }} 
                    className= {"btn  btn-connect-social no-hover " + ( disablebuttons ? "btn-google-disabled" : "btn-google")}>
                        {isLoadingGoogle ? <Loading /> : <span>Ingresar con Google</span>}
                    </button>
                   
                )}
            />
            :
            ""
        }
        {processErrorMsg!=='' && <p className="error-form red-dark"><br />{processErrorMsg}</p>}
        </>
    );
}

SocialAuth.propTypes = {
    showFacebook: PropTypes.bool, 
    showGoogle: PropTypes.bool, 
    actionCall: PropTypes.string,
    disablebuttons: PropTypes.bool,
    legal: PropTypes.object,
    handleTool: PropTypes.func,
    handleLoginValidation: PropTypes.func,
    handleLoginData:PropTypes.func,
    documentInfo:PropTypes.object
};

export default SocialAuth;